// useSortSpeakers.js

const getComparisonValue = (value) => String(value || "").trim();

const getSpeakerCategoryText = (fullName, peopleByName) => {
  const record = peopleByName?.[fullName];
  return String(record?.Category || "");
};

const getSpeakerPriorityRank = (fullName, peopleByName) => {
  const category = getSpeakerCategoryText(fullName, peopleByName);
  if (category.includes("Keynote")) return 1;
  if (category.includes("Showcase")) return 2;
  if (category.includes("Masterclass")) return 3;
  return 50;
};

const getKeynoteShowcaseTieBreakRank = (fullName, peopleByName) => {
  const category = getSpeakerCategoryText(fullName, peopleByName);
  const isKeynote = category.includes("Keynote");
  const isShowcase = category.includes("Showcase");
  if (isKeynote && isShowcase) return 1; // push to end of keynote block
  return 0;
};

const compareIndexedSpeakers = (a, b) => {
  const aName = getComparisonValue(a?.name);
  const bName = getComparisonValue(b?.name);
  if (!aName && !bName) return a.index - b.index;
  if (!aName) return 1;
  if (!bName) return -1;
  const priorityDiff = a.priorityRank - b.priorityRank;
  if (priorityDiff) return priorityDiff;
  const keynoteTieDiff = a.keynoteShowcaseRank - b.keynoteShowcaseRank;
  if (keynoteTieDiff) return keynoteTieDiff;
  return a.index - b.index; // preserve original order otherwise
};

export const useSortSpeakers = (speakers, peopleByName) => {
  const list = Array.isArray(speakers) ? speakers : [];
  const indexed = list.map((name, index) => ({
    name,
    index,
    priorityRank: getSpeakerPriorityRank(name, peopleByName),
    keynoteShowcaseRank: getKeynoteShowcaseTieBreakRank(name, peopleByName)
  }));
  indexed.sort(compareIndexedSpeakers);
  return indexed.map((item) => item.name);
};
